import moment from 'moment';

// Mapbox Static Image API
export const MAP_USERNAME = 'oyojp';
export const MAP_STYLE_ID = 'cl027ii9e001514mok9iju27p';
export const MAP_ZOOM = 14;
export const MAP_BEARING = '0';
export const MAP_PITCH = '0';
export const MAP_WIDTH = 550;
export const MAP_HEIGHT = 250;

// customer detail input validations
export const NAME_MAX_LENGTH = 25;
export const PHONE_MAX_LENGTH = 25;
export const POSTAL_CODE_MAX_LENGTH = 10;
export const REGION_MAX_LENGTH = 10;
export const ADDRESS_MAX_LENGTH = 100;
export const EMAIL_MAX_LENGTH = 100;
export const HOTEL_MESSAGE_MAX_LENGTH = 200;
export const PASSWORD_MAX_LENGTH = 100;
export const PASSWORD_MIN_LENGTH = 10;

// date related constants
export const COMMON_DATE_FORMAT = 'YYYY-MM-DD'; // e.g. 2022-06-16
export const COMMON_DATETIME_FORMAT = 'YYYY/M/D HH:mm'; // e.g. 2022/6/16 13:08
export const COMMON_TIME_FORMAT = 'HH:mm'; // e.g. 13:08
export const ALTERNATE_DATE_FORMAT = 'YYYY/M/D'; // e.g. 2022/6/16 13:08
export const ALTERNATE_DATE_LONG_FORMAT = 'YYYY/M/D(ddd)'; // e.g. 2022/6/16(Thu)
export const JAPANESE_DATE_FORMAT = 'YYYY年M月DD日'; // e.g. 2022年06月16日
export const JAPANESE_DATE_LONG_FORMAT = 'YYYY年MM月DD日 (ddd)'; // e.g. 2022年06月16日 (木)
export const DISPLAY_DATE_FORMAT = 'MMM Do (ddd)'; // eg Jun 3rd (Mon)

// tabist info
export const TABIST_URL = 'www.tabist.co.jp';
export const COPYRIGHT_FALLBACK = '2022-2023 © Tabist株式会社';
export const REGISTRATION_ID = 'T9010403020164';

// customer support info
export const CUSTOMER_SUPPORT_LINE_ACCOUNT_ID = '@814brwwb';
export const CUSTOMER_SUPPORT_EMAIL = 'customer.support@tabist.co.jp';

export const DEFAULT_GUEST_COUNT = '1_0_0_0_0_0_0';
export const DEFAULT_CHECK_IN_DATE_MOMENT = moment().add(7, 'days');
export const DEFAULT_CHECK_IN_DATE = DEFAULT_CHECK_IN_DATE_MOMENT.format(COMMON_DATE_FORMAT);
export const DEFAULT_CHECK_OUT_DATE_MOMENT = moment(DEFAULT_CHECK_IN_DATE).add(1, 'days');
export const DEFAULT_CHECK_OUT_DATE = DEFAULT_CHECK_OUT_DATE_MOMENT.format(COMMON_DATE_FORMAT);

export const CONSUMPTION_TAX_PERCENTAGE = 10;

export enum Affilation {
  WEB = 'web',
}

export enum AuthenticationMethod {
  COGNITO = 'Cognito',
}

export enum AuthenticationStep {
  DELETE_ACCOUNT = 'delete_account',
  LOGIN = 'login',
  LOGOUT = 'logout',
  SIGN_UP = 'sign_up',
}

export enum CognitoAuthProvider {
  APPLE = 'Apple',
  FACEBOOK = 'Facebook',
  GOOGLE = 'Google',
}

export enum CustomAuthProvider {
  LINE = 'line',
  YAHOO = 'Yahoo',
}

export enum BasicTrackingEvent {
  LOGIN = 'login',
  SEARCH = 'search',
  SELECT_CONTENT = 'select_content',
  SIGN_UP = 'sign_up',
  TAG_FILTER = 'tag_filter',
  AREA_FILTER = 'area_filter',
  BUDGET_FILTER = 'budget_filter',
  CLEAR_FILTER = 'clear_filter',
}

export enum BookingStatus {
  CANCELLED = 'cancelled',
  RESERVED = 'reserved',
}

export enum Category {
  HOTEL = 'hotel',
  MEAL_PLAN = 'meal_plan',
  PLAN = 'plan',
  RYOKAN = 'ryokan',
}

export enum ContentType {
  PROPERTY = 'property',
  SEARCH_DROPDOWN = 'search_dropdown',
  BUTTON = 'button',
  TAB = 'tab',
  MEAL_PLAN = 'meal_plan',
  MEAL_PLAN_DETAIL = 'meal_plan_detail',
  FEEDBACK = 'feedback',
  DATE_PICKER = 'date_picker',
}

export enum Currency {
  JPY = 'JPY',
}

export enum EcommerceEvent {
  ADD_PAYMENT_INFO = 'add_payment_info',
  ADD_TO_CART = 'add_to_cart',
  BEGIN_CHECKOUT = 'begin_checkout',
  PURCHASE = 'purchase',
  REFUND = 'refund',
  REMOVE_FROM_CART = 'remove_from_cart',
  SELECT_ITEM = 'select_item',
  SELECT_PROMOTION = 'select_promotion',
  VIEW_ITEM = 'view_item',
  VIEW_ITEM_LIST = 'view_item_list',
  VIEW_PROMOTION = 'view_promotion',
  VIEW_MAP = 'view_map',
  VIEW_MAP_TOP_PAGE = 'view_map_top_page',
  VIEW_MAP_HOTEL_LISTING_PAGE = 'view_map_hotel_listing_page',
  VIEW_MAP_SELECT_HOTEL = 'view_map_select_hotel',
  VIEW_GALLERY = 'view_gallery',
  VIEW_FAQ = 'view_faq',
}

export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
}

/**
 *@see https://github.com/tabist/direct-channel-booking/blob/dev/config/locales/ja.yml
 */
export enum GuestCategory {
  ADULT_FEMALE = 'adult_female',
  ADULT_MALE = 'adult_male',
  INFANT_WITH_FUTON = 'infant_with_futon',
  INFANT_WITH_MEAL = 'infant_with_meal',
  INFANT_WITH_MEAL_AND_FUTON = 'infant_with_meal_and_futon',
  INFANT_WITHOUT_MEAL_AND_FUTON = 'infant_without_meal_and_futon',
  JUNIOR_ELEMENTARY_SCHOOL_CHILD = 'junior_elementary_school_child',
  SENIOR_ELEMENTARY_SCHOOL_CHILD = 'senior_elementary_school_child',
}

export enum GoogleAnalyticsGroup {
  TABIST = 'tabist',
  TRANSCOSMOS = 'transcosmos',
}

export enum GoogleTagType {
  Config = 'config',
  Event = 'event',
  Set = 'set',
}

// Standard locale codes used across the app
// zh-Hans & zh-Hant are used to match BFF/BE API
export const Locale = {
  JAPANESE: 'ja',
  ENGLISH: 'en',
  KOREAN: 'ko',
  CHINESE_SIMPLIFIED: 'zh-Hans',
  CHINESE_TRADITIONAL: 'zh-Hant',
};

// Accept-Language header locale codes for browser language detection
export const AcceptLanguageLocale = {
  JAPANESE: 'ja',
  ENGLISH: 'en',
  KOREAN: 'ko',
  CHINESE_SIMPLIFIED: 'zh-CN',
  CHINESE_TRADITIONAL: 'zh-TW',
};

// Moment.js locale codes for date localization
export const MomentLocale = {
  JAPANESE: 'ja',
  ENGLISH: 'en',
  KOREAN: 'ko',
  CHINESE_SIMPLIFIED: 'zh-CN',
  CHINESE_TRADITIONAL: 'zh-TW',
};

export const MomentLocaleMapping = {
  [Locale.JAPANESE]: MomentLocale.JAPANESE,
  [Locale.ENGLISH]: MomentLocale.ENGLISH,
  [Locale.KOREAN]: MomentLocale.KOREAN,
  [Locale.CHINESE_SIMPLIFIED]: MomentLocale.CHINESE_SIMPLIFIED,
  [Locale.CHINESE_TRADITIONAL]: MomentLocale.CHINESE_TRADITIONAL,
};

export const AcceptLanguageLocaleMapping = {
  [AcceptLanguageLocale.JAPANESE]: Locale.JAPANESE,
  [AcceptLanguageLocale.ENGLISH]: Locale.ENGLISH,
  [AcceptLanguageLocale.KOREAN]: Locale.KOREAN,
  [AcceptLanguageLocale.CHINESE_SIMPLIFIED]: Locale.CHINESE_SIMPLIFIED,
  [AcceptLanguageLocale.CHINESE_TRADITIONAL]: Locale.CHINESE_TRADITIONAL,
} as Record<string, string>;

export const LocaleFlagsMapping = {
  [Locale.JAPANESE]: '/japan-flag-circle.svg',
  [Locale.ENGLISH]: '/usa-flag-circle.svg',
  [Locale.KOREAN]: '/south-korea-flag-circle.svg',
  [Locale.CHINESE_SIMPLIFIED]: '/china-flag-circle.svg',
  [Locale.CHINESE_TRADITIONAL]: '/chinese-flag-circle.svg',
};

// online payment method (tabistPaymentTypes in PDM)
export enum PaymentMethod {
  CREDIT_CARD = 'credit_card',
  CREDIT_CARD2 = 'credit3d2',
  PAY_AT_HOTEL = 'pay_at_hotel',
  PAYPAY = 'paypay',
  PAYPAY_HIVEX = 'paypay_hivex',
}

export enum PhotoCategory {
  ALL = 'すべての写真',
  ROOMS = '部屋',
  FACILITIES = '施設',
  SIGHTSEEING = '周辺観光・グルメ',
  MEALS = '食事',
  OTHERS = 'その他',
}

export enum PromotionType {
  CAMPAIGN_BANNER = 'campaign_banner',
  FEATURED_HOTELS = 'featured_hotels',
  FLAGSHIP_HOTELS = 'flagship_hotels',
  HERO_BANNER = 'hero_banner',
  MAGAZINE_BANNER = 'magazine_banner',
}

// payment method at hotel (propertyPaymentTypes in PDM)
export enum PropertyPaymentMethod {
  CASH = 'cash',
  CREDIT_CARD = 'credit_card',
  PAYPAY = 'paypay',
}

export enum TimeOfPayment {
  PREPAY = 'prepay',
  ON_SITE_PAYMENT = 'on_site_payment',
}

export enum TravelPurpose {
  LEISURE = 'leisure',
  WORK = 'work',
}

export enum MiniSiteTabOptions {
  HOTEL_DETAILS = 'hotel_details',
  ROOMS = 'rooms',
  GALLERY = 'gallery',
}

export enum DiscountType {
  CAMPAIGN = 'campaign',
  ZENKOKU = 'zenkoku',
  COUPON = 'coupon',
  PROMOTION = 'promotion_tier', // Voucherify Camapign
  VOUCHER = 'voucher', // Voucherify Coupon
}

export enum DiscountCalculationType {
  PERCENTAGE = 'percent',
  AMOUNT = 'amount',
}

export enum PartnershipLevel {
  FLAGSHIP = 'flagship',
  STANDARD = 'standard',
  WHITELABEL = 'whitelabel',
  THIRD_PARTY = 'third-party',
}

export enum AuthenticationModalCard {
  LOGIN = 'login',
  SIGN_UP = 'sign_up',
  SIGN_UP_CONFIRMED = 'sign_up_confirmed',
}

// app prompt URL
export const APP_HOTEL_PAGE = (hotelId: string) =>
  `https://tabistapp.page.link/?ibi=com%2Etabist%2Ebooking&isi=1621250313&apn=com%2Etabist%2Ebooking&link=https%3A%2F%2Fwww%2Ehpdsp%2Enet%2Ftateshina%2Fhw%2Fhwp3100%2Fhww3101%2Edo%3FyadNo%3D325184%26hotel%5Fid%3D${hotelId}%26screen%5Fname%3DPlaceDetailTabScreen`;
export const APP_TOAST = 'https://tabistapp.page.link/toast';

export const MAPBOX_STYLE = 'mapbox://styles/oyojp/clphk7otq005m01q1hl84goku';

export const SUPPORTED_CREDIT_CARD_BY_SBPS = [
  'VISA',
  'Mastercard',
  'JCB',
  'American Express',
  'Diners Club',
];

export const SocialProviderSequence = [
  process.env.NEXT_PUBLIC_FEATURE_FLAG_SSO_GOOGLE ? CognitoAuthProvider.GOOGLE : undefined,
  process.env.NEXT_PUBLIC_FEATURE_FLAG_SSO_APPLE ? CognitoAuthProvider.APPLE : undefined,
  process.env.NEXT_PUBLIC_FEATURE_FLAG_SSO_FACEBOOK ? CognitoAuthProvider.FACEBOOK : undefined,
  process.env.NEXT_PUBLIC_FEATURE_FLAG_SSO_LINE ? CustomAuthProvider.LINE : undefined,
  process.env.NEXT_PUBLIC_FEATURE_FLAG_SSO_YAHOO ? CustomAuthProvider.YAHOO : undefined,
];

export enum CollageType {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT',
  PORTRAIT_LANDSCAPE = 'PORTRAIT_LANDSCAPE',
  TWO_LANDSCAPES = 'TWO_LANDSCAPES',
  THREE_LANDSCAPES = 'THREE_LANDSCAPES',
  TWO_PORTRAITS = 'TWO_PORTRAITS',
  THREE_PORTRAITS = 'THREE_PORTRAITS',
  ONE_PORTRAIT_TWO_LANDSCAPES = 'ONE_PORTRAIT_TWO_LANDSCAPES',
}

export enum FeedbackURL {
  BOOKING_EXPERIENCE = '/feedback/booking-experience',
  WEBSITE = '/feedback/website',
}

export const FEEDBACK_REDIRECT_MAP_EN: Record<string, string | undefined> = {
  [FeedbackURL.BOOKING_EXPERIENCE]: process.env.NEXT_PUBLIC_FEEDBACK_FORM_URL_BOOKING_EXPERIENCE_EN,
  [FeedbackURL.WEBSITE]: process.env.NEXT_PUBLIC_FEEDBACK_FORM_URL_WEBSITE_EN,
};

export const FEEDBACK_REDIRECT_MAP_JA: Record<string, string | undefined> = {
  [FeedbackURL.BOOKING_EXPERIENCE]: process.env.NEXT_PUBLIC_FEEDBACK_FORM_URL_BOOKING_EXPERIENCE_JA,
  [FeedbackURL.WEBSITE]: process.env.NEXT_PUBLIC_FEEDBACK_FORM_URL_WEBSITE_JA,
};

export const PRICE_OPTIONS = [
  ...Array.from(Array(10)).map((_, index) => index + 1),
  12,
  14,
  16,
  18,
  20,
  30,
  40,
  50,
  60,
  70,
  80,
  90,
  100,
  150,
  200,
].map((price) => price * 1000);

export enum ReceiptGenerationStatus {
  PENDING = 'pending',
  GENERATED = 'generated',
  DELETED = 'deleted',
  ERRORED = 'errored',
}

export enum SearchStatus {
  PREFECTURE = 'PREFECTURE',
  DATE = 'DATE',
  GUEST = 'GUEST',
}

export const HOTEL_SEARCH_DEBOUNCE_DELAY_MS = Number(
  process.env.NEXT_PUBLIC_HOTEL_SEARCH_DEBOUNCE_DELAY_MS || 300
);

export const FACILITY_DESCRIPTION = {
  AVAILABLE_JA: 'あり',
  AVAILABLE_EN: 'Available',
  UNAVAILABLE_JA: 'なし',
  UNAVAILABLE_EN: 'Not available',
};

export const REVIEW_SUB_CATEGORIES = ['service', 'location', 'room', 'facility', 'bath', 'meal'];
